import { Link, useLocation } from "react-router-dom";
import React, { useState } from "react";
import { useDonation } from "./DonationContext";
import "./Header.css";

const Header = () => {
  const { openDonation } = useDonation();
  const location = useLocation();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({}); // track submenu state

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleSubmenu = (key) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const isActive = (path) =>
    path !== "/" ? location.pathname.startsWith(path) : location.pathname === "/";

  return (
    /* FIX: Fragment wraps the header + a spacer div. The header is now
       `position: fixed` (see Header.css) so it always stays visible on
       scroll, regardless of any parent overflow/transform styles that
       were previously breaking `position: sticky`. The spacer div takes
       up the same height the header used to occupy in normal flow, so
       page content below doesn't get hidden underneath it. */
    <>
      <header className="vh-header">
        {/* ---------- Top bar ---------- */}
        <div className="vh-topbar">
          <div className="container">
            <div className="vh-topbar__inner">
              <ul className="vh-topbar__contact">
                <li>
                  <span className="vh-icon-badge">
                    <i className="fa-solid fa-envelope" />
                  </span>
                  <a href="mailto:info@vikash.org">info@vikash.org</a>
                </li>
                <li>
                  <span className="vh-icon-badge">
                    <i className="fa-solid fa-phone" />
                  </span>
                  <a href="tel:+916742548306">+91-674-2548306</a>
                </li>
                <li>
                  <span className="vh-icon-badge">
                    <i className="fa-solid fa-location-dot" />
                  </span>
                  <a
                    href="https://maps.app.goo.gl/vUvJupxoQhiFALud6"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Rasulgarh, Bhubaneswar, Odisha 751010
                  </a>
                </li>
              </ul>

              <div className="vh-topbar__social">
                <span className="vh-topbar__social-label">Follow Us :</span>
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/vikashNGOindia/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <i className="fa-brands fa-facebook-f" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://x.com/VikashIndia1"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Twitter"
                    >
                      <i className="fa-brands fa-twitter" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/vikashbbsr/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                    >
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@Vikashngobbsr"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Youtube"
                    >
                      <i className="fa-brands fa-youtube" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/vikash-vikash-802a3826/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn"
                    >
                      <i className="fa-brands fa-linkedin-in" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* ---------- Main nav ---------- */}
        <div className="vh-navbar">
          <div className="container">
            <div className="vh-navbar__inner">
              <Link to="/" className="vh-logo">
                <img src="assets/images/resources/lg.png" alt="Vikash logo" />
              </Link>

              <button
                className="vh-mobile-toggler"
                onClick={toggleMobileMenu}
                aria-label="Open menu"
              >
                <i className="fa fa-bars" />
              </button>

              <nav className="vh-menu">
                <ul>
                  <li className={isActive("/") ? "is-active" : ""}>
                    <Link to="/">Home</Link>
                  </li>

                  <li className={`vh-has-dropdown ${isActive("/about-vikash") ? "is-active" : ""}`}>
                    <Link to="/about-vikash">
                      About Us <i className="fa fa-angle-down" />
                    </Link>
                    <ul className="vh-dropdown">
                      <li>
                        <Link to="/about-vikash">About Vikash</Link>
                      </li>
                      <li>
                        <Link to="/vision-mission">Vision & Mission</Link>
                      </li>
                      <li>
                        <Link to="/our-partners">Our Partners</Link>
                      </li>
                      <li>
                        <Link to="/our-team">Our Team</Link>
                      </li>
                    </ul>
                  </li>

                  <li className="vh-has-dropdown">
                    <Link to="#">
                      Programs <i className="fa fa-angle-down" />
                    </Link>
                    <ul className="vh-dropdown">
                      <li className="vh-has-dropdown">
                        <Link to="/sustainable-livelihoods">
                          Sustainable Livelihoods <i className="fa fa-angle-right" />
                        </Link>
                        <ul className="vh-dropdown vh-dropdown--nested">
                          <li>
                            <Link to="/agriculture-livelihood">Agriculture Livelihood</Link>
                          </li>
                          <li>
                            <Link to="/non-farm-based-livelihood">
                              Non Farm Based Livelihood
                            </Link>
                          </li>
                        </ul>
                      </li>

                      <li>
                        <Link to="/health">Health</Link>
                      </li>

                      <li className="vh-has-dropdown">
                        <Link to="/quality-education">
                          Quality Education <i className="fa fa-angle-right" />
                        </Link>
                        <ul className="vh-dropdown vh-dropdown--nested">
                          <li>
                            <Link to="/non-formal-education">Non-Formal Education</Link>
                          </li>
                          <li>
                            <Link to="/creche-program">Creche Program</Link>
                          </li>
                          <li>
                            <Link to="/child-labour-prevention">Child Labour Prevention</Link>
                          </li>
                          <li>
                            <Link to="/caring-for-tribal-children">
                              Caring For Tribal Children
                            </Link>
                          </li>
                          <li>
                            <Link to="/inclusive-education">Inclusive Education</Link>
                          </li>
                          <li>
                            <Link to="/children-parliament">Childrens Parliament</Link>
                          </li>
                          <li>
                            <Link to="/advocacy-networking">Advocacy And Networking</Link>
                          </li>
                          <li>
                            <Link to="/special-centers">Special Centers</Link>
                          </li>
                        </ul>
                      </li>

                      <li className="vh-has-dropdown">
                        <Link to="/good-governance">
                          Good Governance <i className="fa fa-angle-right" />
                        </Link>
                        <ul className="vh-dropdown vh-dropdown--nested">
                          <li>
                            <Link to="/rural-governance">Rural Governance</Link>
                          </li>
                          <li>
                            <Link to="/urban-governance">Urban Governance</Link>
                          </li>
                        </ul>
                      </li>

                      <li className="vh-has-dropdown">
                        <Link to="/opportunities-for-the-disabled">
                          Opportunities For The Disabled <i className="fa fa-angle-right" />
                        </Link>
                        <ul className="vh-dropdown vh-dropdown--nested">
                          <li>
                            <Link to="/health1">Health</Link>
                          </li>
                          <li>
                            <Link to="/education-and-behavior-development">
                              Education And Behavior Development
                            </Link>
                          </li>
                          <li>
                            <Link to="/economic-development">Economic Development</Link>
                          </li>
                          <li>
                            <Link to="/social-development">Social Development</Link>
                          </li>
                        </ul>
                      </li>

                      <li className="vh-has-dropdown">
                        <Link to="/good-habitat">
                          Good Habitat <i className="fa fa-angle-right" />
                        </Link>
                        <ul className="vh-dropdown vh-dropdown--nested vh-dropdown--up">
                          <li>
                            <Link to="/housing">Housing</Link>
                          </li>
                          <li>
                            <Link to="/forestry">Forestry</Link>
                          </li>
                          <li>
                            <Link to="/renewable-energy">Renewable Energy</Link>
                          </li>
                          <li>
                            <Link to="/water">Water</Link>
                          </li>
                          <li>
                            <Link to="/sanitation">Sanitation</Link>
                          </li>
                          <li>
                            <Link to="/solid-waste-management">Solid Waste Management</Link>
                          </li>
                          <li>
                            <Link to="/bio-medical-waste-management">
                              Bio-Medical Waste Management
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>

                  <li className="vh-has-dropdown">
                    <Link to="#">
                      Media <i className="fa fa-angle-down" />
                    </Link>
                    <ul className="vh-dropdown">
                      <li>
                        <Link to="/news">News</Link>
                      </li>
                      <li>
                        <Link to="/photo-gallery">Photo Gallery</Link>
                      </li>
                      <li>
                        <Link to="/video-gallery">Video Gallery</Link>
                      </li>
                    </ul>
                  </li>

                  <li className="vh-has-dropdown">
                    <Link to="#">
                      Resources <i className="fa fa-angle-down" />
                    </Link>
                    <ul className="vh-dropdown">
                      <li>
                        <Link to="/research-publications">Research & Publications</Link>
                      </li>
                      <li>
                        <Link to="/case-studies">Case Studies</Link>
                      </li>
                      <li>
                        <Link to="/annual-reports">Annual Reports</Link>
                      </li>
                      <li>
                        <Link to="/events-reports">Events Reports</Link>
                      </li>
                    </ul>
                  </li>

                  <li className="vh-has-dropdown">
                    <Link to="#">
                      Join Us <i className="fa fa-angle-down" />
                    </Link>
                    <ul className="vh-dropdown">
                      <li>
                        <Link to="/volunteer">Volunteers</Link>
                      </li>
                      <li>
                        <Link to="/interns">Interns</Link>
                      </li>
                      <li>
                        <Link to="/career">Career</Link>
                      </li>
                    </ul>
                  </li>

                  <li className={isActive("/blog") ? "is-active" : ""}>
                    <Link to="/blog">Blog</Link>
                  </li>

                  <li className={isActive("/contact-us") ? "is-active" : ""}>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                </ul>
              </nav>

              <div className="vh-navbar__actions">
                <button className="vh-donate-btn" type="button" onClick={openDonation}>
                  <i className="fa-solid fa-heart" /> Donate Now
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ---------- Mobile Nav ---------- */}
        <div className={`vh-mobile-nav ${isMobileMenuOpen ? "is-expanded" : ""}`}>
          <div className="vh-mobile-nav__overlay" onClick={toggleMobileMenu} />
          <div className="vh-mobile-nav__content">
            <button
              className="vh-mobile-nav__close"
              onClick={toggleMobileMenu}
              aria-label="Close Menu"
            >
              <i className="fa fa-times" />
            </button>

            <div className="vh-mobile-nav__logo">
              <Link to="/" onClick={toggleMobileMenu}>
                <img src="assets/images/resources/lg.png" width={140} alt="logo" />
              </Link>
            </div>

            <div className="vh-mobile-nav__container">
              <ul>
                <li>
                  <Link to="/" onClick={toggleMobileMenu}>
                    Home
                  </Link>
                </li>

                <li className={openSubmenus["about"] ? "is-open" : ""}>
                  <button
                    className="vh-mobile-submenu-toggle"
                    onClick={() => toggleSubmenu("about")}
                    aria-expanded={!!openSubmenus["about"]}
                  >
                    About Us <i className="fa fa-angle-down" />
                  </button>
                  {openSubmenus["about"] && (
                    <ul className="vh-mobile-submenu">
                      <li>
                        <Link to="/about-vikash" onClick={toggleMobileMenu}>
                          About Vikash
                        </Link>
                      </li>
                      <li>
                        <Link to="/vision-mission" onClick={toggleMobileMenu}>
                          Vision & Mission
                        </Link>
                      </li>
                      <li>
                        <Link to="/our-partners" onClick={toggleMobileMenu}>
                          Our Partners
                        </Link>
                      </li>
                      <li>
                        <Link to="/our-team" onClick={toggleMobileMenu}>
                          Our Team
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li className={openSubmenus["programs"] ? "is-open" : ""}>
                  <button
                    className="vh-mobile-submenu-toggle"
                    onClick={() => toggleSubmenu("programs")}
                    aria-expanded={!!openSubmenus["programs"]}
                  >
                    Programs <i className="fa fa-angle-down" />
                  </button>
                  {openSubmenus["programs"] && (
                    <ul className="vh-mobile-submenu">
                      <li>
                        <Link to="/sustainable-livelihoods" onClick={toggleMobileMenu}>
                          Sustainable Livelihoods
                        </Link>
                      </li>
                      <li>
                        <Link to="/health" onClick={toggleMobileMenu}>
                          Health
                        </Link>
                      </li>
                      <li>
                        <Link to="/quality-education" onClick={toggleMobileMenu}>
                          Quality Education
                        </Link>
                      </li>
                      <li>
                        <Link to="/good-governance" onClick={toggleMobileMenu}>
                          Good Governance
                        </Link>
                      </li>
                      <li>
                        <Link to="/opportunities-for-the-disabled" onClick={toggleMobileMenu}>
                          Opportunities For The Disabled
                        </Link>
                      </li>
                      <li>
                        <Link to="/good-habitat" onClick={toggleMobileMenu}>
                          Good Habitat
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li className={openSubmenus["media"] ? "is-open" : ""}>
                  <button
                    className="vh-mobile-submenu-toggle"
                    onClick={() => toggleSubmenu("media")}
                    aria-expanded={!!openSubmenus["media"]}
                  >
                    Media <i className="fa fa-angle-down" />
                  </button>
                  {openSubmenus["media"] && (
                    <ul className="vh-mobile-submenu">
                      <li>
                        <Link to="/news" onClick={toggleMobileMenu}>
                          News
                        </Link>
                      </li>
                      <li>
                        <Link to="/photo-gallery" onClick={toggleMobileMenu}>
                          Photo Gallery
                        </Link>
                      </li>
                      <li>
                        <Link to="/video-gallery" onClick={toggleMobileMenu}>
                          Video Gallery
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li className={openSubmenus["resources"] ? "is-open" : ""}>
                  <button
                    className="vh-mobile-submenu-toggle"
                    onClick={() => toggleSubmenu("resources")}
                    aria-expanded={!!openSubmenus["resources"]}
                  >
                    Resources <i className="fa fa-angle-down" />
                  </button>
                  {openSubmenus["resources"] && (
                    <ul className="vh-mobile-submenu">
                      <li>
                        <Link to="/research-publications" onClick={toggleMobileMenu}>
                          Research & Publications
                        </Link>
                      </li>
                      <li>
                        <Link to="/case-studies" onClick={toggleMobileMenu}>
                          Case Studies
                        </Link>
                      </li>
                      <li>
                        <Link to="/annual-reports" onClick={toggleMobileMenu}>
                          Annual Reports
                        </Link>
                      </li>
                      <li>
                        <Link to="/events-reports" onClick={toggleMobileMenu}>
                          Events Reports
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li className={openSubmenus["join"] ? "is-open" : ""}>
                  <button
                    className="vh-mobile-submenu-toggle"
                    onClick={() => toggleSubmenu("join")}
                    aria-expanded={!!openSubmenus["join"]}
                  >
                    Join Us <i className="fa fa-angle-down" />
                  </button>
                  {openSubmenus["join"] && (
                    <ul className="vh-mobile-submenu">
                      <li>
                        <Link to="/volunteer" onClick={toggleMobileMenu}>
                          Volunteers
                        </Link>
                      </li>
                      <li>
                        <Link to="/interns" onClick={toggleMobileMenu}>
                          Interns
                        </Link>
                      </li>
                      <li>
                        <Link to="/career" onClick={toggleMobileMenu}>
                          Career
                        </Link>
                      </li>
                      <li>
                        <Link to="/internship" onClick={toggleMobileMenu}>
                          Internship
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li>
                  <Link to="/blog" onClick={toggleMobileMenu}>
                    Blog
                  </Link>
                </li>

                <li>
                  <Link to="/contact-us" onClick={toggleMobileMenu}>
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            <div className="vh-mobile-nav__footer">
              <ul className="vh-mobile-nav__contact">
                <li>
                  <i className="fa-solid fa-envelope" />
                  <a href="mailto:info@vikash.org">info@vikash.org</a>
                </li>
                <li>
                  <i className="fa-solid fa-phone" />
                  <a href="tel:+916742548306">+91-674-2548306</a>
                </li>
              </ul>

              <div className="vh-mobile-nav__social">
                <a href="https://x.com/VikashIndia1" aria-label="Twitter">
                  <i className="fa-brands fa-twitter" />
                </a>
                <a href="https://www.facebook.com/vikashNGOindia" aria-label="Facebook">
                  <i className="fa-brands fa-facebook-square" />
                </a>
                <a href="https://www.youtube.com/@Vikashngobbsr" aria-label="Youtube">
                  <i className="fa-brands fa-youtube" />
                </a>
                <a href="https://www.instagram.com/vikashbbsr" aria-label="Instagram">
                  <i className="fa-brands fa-instagram" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* FIX: spacer to offset the now-fixed header's height so page
          content doesn't render underneath it */}
      <div className="vh-header-spacer" />
    </>
  );
};

export default Header;